import { useTranslation } from 'next-i18next';
import classnames from 'classnames';

import { Alert, Icon } from '@components/ui';

import styles from './PhoneVerificationHelp.module.scss';

interface Props {
  className?: string
}

const PhoneVerificationHelp = (props: Props) => {
  const { className } = props;

  const { t } = useTranslation();

  return (
    <Alert
      className={classnames(styles.root, className)}
      iconClassName={styles.icon}
      contentClassName={styles.content}
      description={() => {
        return (
          <p>
            {t('PHONE_VALIDATION.HELP.TEXT_BEFORE')}
            <a
              className={styles.link}
              href={`mailto:${t('PHONE_VALIDATION.HELP.LINK')}`}
            >
              {t('PHONE_VALIDATION.HELP.LINK')}
            </a>
            {t('PHONE_VALIDATION.HELP.TEXT_AFTER')}
          </p>
        );
      }}
      variant="custom"
      icon={<Icon name="info-circle" size={20} />}
    />
  );
};

export default PhoneVerificationHelp;
